export const name = 'renderFlagsOverridesAspect'

export const defaultModel = {}
